// extracted by mini-css-extract-plugin
module.exports = {"Message":"ChatMessage_Message__3Yue5","SenderName":"ChatMessage_SenderName__1TTlR","Sent":"ChatMessage_Sent__1csLF"};